import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, Observable, retry } from 'rxjs'
import { SharedValue } from '../../../models/enum/shared.enum'
import { AppConfigurationService } from '../../app-configuration.service'
import { CutOff, Month } from './calendar.model'

@Injectable({
  providedIn: 'root'
})
export class CalendarService {
  public readonly baseUrl: string

  constructor(
    private http: HttpClient,
    private appConfigurationService: AppConfigurationService
  ) {
    this.baseUrl = this.appConfigurationService.getBaseSiteUrl()
  }

  public getHolidays(): Observable<string[]> {
    const url = `${this.baseUrl}/orgUsers/current/deliveryCalendar/getHolidays`

    return this.http.get<any>(url).pipe(
      retry(1),
      catchError(() => {
        throw new Error(SharedValue.errorTryAgain)
      })
    )
  }

  public getCalendarMonths(): Observable<Month[]> {
    const url = `${this.baseUrl}/orgUsers/current/calendar/months`

    return this.http.get<any>(url).pipe(
      retry(1),
      catchError(() => {
        throw new Error(SharedValue.errorTryAgain)
      })
    )
  }

  public getCutOffTime(): Observable<CutOff> {
    const url = `${this.baseUrl}/cutOffTime`

    return this.http.get<any>(url).pipe(
      retry(1),
      catchError(() => {
        throw new Error(SharedValue.errorTryAgain)
      })
    )
  }
}
